import { render, staticRenderFns } from "./userfeedback.vue?vue&type=template&id=93ebe07a&"
import script from "./userfeedback.vue?vue&type=script&lang=js&"
export * from "./userfeedback.vue?vue&type=script&lang=js&"
import style0 from "./userfeedback.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports